// Catalogo dei permessi. Gruppi e ordine seguono il MENU a sinistra (Generale, Agenti,
// Lavoro) cosi' chi assegna spunta quello che l'utente poi vedra'. Le chiavi non cambiano
// mai: cambiare una key farebbe perdere i permessi gia' assegnati agli utenti.
//   nota:    cosa accende la voce oltre alla pagina (una riga, mostrata sotto l'etichetta)
//   dipende: chiave senza la quale la voce non serve (la casella si ingrigisce)
//   sezione: sottotitolo dentro il gruppo (solo Impostazioni)
export const PERM_GROUPS = [
  {
    titolo: 'Generale',
    voci: [
      { key: 'dashboard', label: 'Dashboard', nota: 'La pagina iniziale' },
      { key: 'dash_kpi', label: 'KPI e riepilogo', dipende: 'dashboard' },
      { key: 'dash_analisi', label: 'Analisi regione e provincia', dipende: 'dashboard' },
      { key: 'dash_bonta', label: 'Bontà numeri', dipende: 'dashboard' },
      { key: 'dash_export', label: 'Esportazione e Manda all’Export', dipende: 'dashboard' },
      { key: 'export_hub', label: 'Export Hub' },
      { key: 'priorita', label: 'Priorità export', nota: 'I lotti si scaricano dallo Storico di Export' },
      { key: 'analisi', label: 'Analisi', nota: 'Mappa e qualità della rete' },
      { key: 'numeri', label: 'Elenco numeri' },
      { key: 'import', label: 'Import' },
      { key: 'export', label: 'Export', nota: 'Crea e scarica i lotti, con lo Storico' },
      { key: 'copertura', label: 'Copertura liste', nota: 'Anche «Copertura TIM (sito)» nel menu AI' },
    ],
  },
  {
    titolo: 'Agenti',
    voci: [
      { key: 'verifiche', label: 'AI 456 · Verifiche', nota: 'Pagine Verifiche e Cruscotto AI 456' },
      { key: 'cruscotto_456', label: 'Cruscotto 456' },
      { key: 'agente_copertura', label: 'Copertura · sito TIM', nota: 'Tab «Sito TIM» e «Proiezione» della pagina Copertura; spia e colonna copertura' },
      { key: 'ssmate', label: 'AI SSMATE · Lucchetto', nota: 'Spia e accensione; filtro e colonna Lucchetto; «Verifica Lucchetto» nel menu AI' },
      { key: 'ssmate_copertura', label: 'Copertura · SalesMate', nota: 'Tab «SalesMate» della pagina Copertura e il menu AI' },
      { key: 'gea', label: 'AI VF · Vodafone', nota: 'Spia e accensione; logo e filtro Vodafone nei numeri; colonna in Export' },
    ],
  },
  {
    titolo: 'Lavoro',
    voci: [
      { key: 'ricerca_online', label: 'Verifica online', nota: 'Anche «Verifica 456» nel menu AI' },
      { key: 'strumenti', label: 'Strumenti', nota: 'Priorità, esclusioni, blacklist' },
      { key: 'domini_rivedere', label: 'Domini da rivedere' },
      { key: 'campagne', label: 'Campagne TIM', nota: 'Spia e accensione dell’agente Campagne' },
      { key: 'vicine_completare', label: 'Aziende da completare' },
      { key: 'salute', label: 'Salute' },
    ],
  },
  {
    titolo: 'Strumenti nel menu AI',
    voci: [
      { key: 'indaga', label: 'Indaga numero', nota: 'Anche nella lista numeri' },
      { key: 'dominio', label: 'Verifica dominio' },
      { key: 'vicine', label: 'Aziende vicine' },
    ],
  },
  {
    titolo: 'Impostazioni',
    voci: [
      { key: 'imp_tema', label: 'Tema e aspetto', sezione: 'Personali' },
      { key: 'imp_licenza', label: 'Licenza (solo stato)', sezione: 'Personali' },
      { key: 'imp_456', label: 'Verifica 456 (timing)', sezione: 'Agenti' },
      { key: 'imp_copertura', label: 'Copertura TIM', sezione: 'Agenti' },
      { key: 'imp_vf', label: 'AI VF / Vodafone', sezione: 'Agenti' },
      { key: 'imp_disservizio', label: 'Disservizio 456', sezione: 'Agenti' },
      { key: 'imp_notifiche', label: 'Notifiche email', sezione: 'Comunicazioni' },
      { key: 'imp_report', label: 'Report automatico', sezione: 'Comunicazioni' },
      { key: 'imp_export', label: 'Export automatico', sezione: 'Comunicazioni' },
      { key: 'imp_accessi_pubblici', label: 'Link pubblici', sezione: 'Accessi' },
    ],
  },
];

// Cose che restano dell'amministratore: mostrate col lucchetto, NON sono chiavi assegnabili.
export const SOLO_ADMIN = [
  'Utenti', 'Utilizzo', 'Cronologia accessi', 'SalesMate (credenziali e coda)',
  'Impostazioni · Sistema', 'Server email (SMTP)', 'Attivazione licenza', 'Indaga · completa indirizzi',
];

export function tutteLeChiavi() {
  return PERM_GROUPS.flatMap((g) => g.voci.map((v) => v.key));
}

// La casella e' ingrigita quando manca la voce da cui dipende.
export function voceSpenta(voce, permessi) {
  return Boolean(voce.dipende) && !(permessi || []).includes(voce.dipende);
}

// Combinazioni che lasciano l'utente a meta'. Pura: permessi -> elenco di frasi.
export function avvisiPermessi(permessi) {
  const p = new Set(permessi || []);
  const out = [];
  if (p.has('priorita') && !p.has('export')) {
    out.push('Priorità export senza Export: può creare i lotti ma non scaricarli (si scaricano dallo Storico di Export).');
  }
  if (p.has('campagne') && !p.has('numeri')) {
    out.push('Campagne TIM senza Elenco numeri: non vede i record che le campagne portano in archivio.');
  }
  if (!p.has('dashboard') && [...p].some((k) => k.startsWith('dash_'))) {
    out.push('Widget della Dashboard senza Dashboard: non si vedono.');
  }
  return out;
}

// Sotto-sezioni di Impostazioni: l'accesso alla pagina è dato da almeno una di queste.
export const SETTINGS_KEYS = ['imp_tema', 'imp_export', 'imp_licenza', 'imp_copertura', 'imp_456', 'imp_vf', 'imp_disservizio', 'imp_notifiche', 'imp_report', 'imp_accessi_pubblici'];

// Pre-selezione di default per un nuovo operatore (e' anche il profilo «Operatore base»).
export const DEFAULT_PERMS = ['dashboard', 'numeri', 'verifiche', 'copertura', 'agente_copertura', 'strumenti', 'salute', 'dash_kpi', 'dash_analisi'];

// Ordine delle sezioni-pagina (per scegliere la prima consentita).
export const SECTION_ROUTES = [
  { key: 'dashboard', path: '/' },
  { key: 'export_hub', path: '/export-hub' },
  { key: 'priorita', path: '/esportabili' },
  { key: 'numeri', path: '/numeri' },
  { key: 'import', path: '/import' },
  { key: 'export', path: '/export' },
  { key: 'verifiche', path: '/verifiche' },
  { key: 'cruscotto_456', path: '/cruscotto-456' },
  { key: 'copertura', path: '/copertura' },
  { key: 'agente_copertura', path: '/coperture' },
  { key: 'analisi', path: '/analisi' },
  { key: 'strumenti', path: '/strumenti' },
  { key: 'domini_rivedere', path: '/domini-rivedere' },
  { key: 'campagne', path: '/campagne' },
  { key: 'vicine_completare', path: '/aziende-da-completare' },
  { key: 'salute', path: '/salute' },
  { key: 'ricerca_online', path: '/ricerca-online' },
  { key: 'impostazioni', path: '/impostazioni' },
];

// Profili pronti: un clic sostituisce la selezione, poi si rifinisce a mano.
export const PROFILI = [
  { nome: 'Operatore base', permessi: DEFAULT_PERMS },
  { nome: 'Export', permessi: ['dashboard', 'dash_kpi', 'dash_export', 'numeri', 'export', 'export_hub', 'priorita'] },
  { nome: 'Campagne', permessi: ['numeri', 'campagne'] },
  { nome: 'Tutto tranne admin', permessi: tutteLeChiavi() },
];

export function profiloUguale(profilo, permessi) {
  const a = new Set(profilo.permessi);
  const b = new Set(permessi || []);
  return a.size === b.size && [...a].every((k) => b.has(k));
}
